import { Monitor, Moon, Sun } from 'lucide-react';

import { ThemeMode } from '@shigo-ui/theme';
import { Button, cn } from '@shigo-ui/ui';

import { dashboardT, type DashboardMessageKey } from '../../lib/messages';

export interface ThemeModeToggleProps {
  themeMode: ThemeMode;
  onChange: (themeMode: ThemeMode) => void;
  className?: string;
}

const THEME_OPTIONS: ReadonlyArray<{
  mode: ThemeMode;
  labelKey: DashboardMessageKey;
  icon: typeof Sun;
}> = [
  { mode: ThemeMode.Light, labelKey: 'theme.light', icon: Sun },
  { mode: ThemeMode.Dark, labelKey: 'theme.dark', icon: Moon },
  { mode: ThemeMode.System, labelKey: 'theme.system', icon: Monitor },
];

export function ThemeModeToggle({ themeMode, onChange, className }: ThemeModeToggleProps) {
  return (
    <div
      aria-label={dashboardT('account.appearance')}
      className={cn('bg-muted grid grid-cols-3 gap-1 rounded-md p-1', className)}
      role="group"
    >
      {THEME_OPTIONS.map(({ mode, labelKey, icon: Icon }) => {
        const isActive = themeMode === mode;
        const label = dashboardT(labelKey);

        return (
          <Button
            aria-label={label}
            aria-pressed={isActive}
            className="h-8 justify-center"
            key={mode}
            onClick={() => {
              onChange(mode);
            }}
            size="sm"
            title={label}
            variant={isActive ? 'secondary' : 'ghost'}
          >
            <Icon className="h-4 w-4" />
          </Button>
        );
      })}
    </div>
  );
}
